<app-recent-routes-display
  [recents]="recents$ | async"
  [inHeader]="inHeader"
></app-recent-routes-display>
